import User from "@/assets/js/models/user/User";
import i18n from "../plugins/vueI18n";
import { AuthenticationApi } from "@/assets/js/ApiInterface";
import AuthData from "@/assets/js/models/user/AuthData";
import { updateAuthenticatedUser } from "./middlewareApiCalls";
const appDefaultMiddleware = ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  if (!store.getters.getToken) store.dispatch('removeUser');
  return nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index);
};
const isLoggedAndActive = async ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  let user = store.getters.getAuthUser;
  let token = store.getters.getToken;
  let isUser = user instanceof User;
  let local = i18n.locale;
  if (!isUser || !token) {
    return next(`/${local}/login`);
  }

  /*    if (isUser && user.isInactive()) {
          return next(`/${local}/validation-request`)
      }*/

  return nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index);
};
const isLogged = async ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  await updateAuthenticatedUser({
    store
  });
  let authenticatedUser = store.getters.getAuthUser;
  let isUser = authenticatedUser instanceof User;
  let local = i18n.locale;
  if (authenticatedUser instanceof User && authenticatedUser.isActive()) {
    return next(`/${local}`);
  }
  if (!isUser || !store.getters.getToken || !authenticatedUser.isInactive()) {
    return next(`/${local}/login`);
  }
  return nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index);
};
const emailVerification = async ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  try {
    let {
      data
    } = await await store.dispatch('SendRequest', AuthenticationApi.checkEmail(`?evt=${to.params.token}`, AuthData));
    if (data instanceof AuthData) {
      await store.dispatch('setAuthData', data);
    }
  } catch (e) {
    console.log('email verification failure', e);
  }
  return nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index);
};
const alreadyLogged = async ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  let authenticatedUser = store.getters.authenticatedUser;
  let isUser = authenticatedUser instanceof User;
  if (isUser && authenticatedUser.isActive() && store.getters.getToken) return next(`/${i18n.locale}`);
  return nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index);
};
const nextMiddleware = ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  return middlewares[++index] ? middlewares[index]({
    to,
    from,
    next
  }, store, middlewares, index) : next();
};
const hasPermission = ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  var _to$meta, _to$meta2;
  return store.getters.authenticatedUserHasPermission((_to$meta = to.meta) === null || _to$meta === void 0 ? void 0 : _to$meta.mcn_permission) && store.getters.authenticatedUserHasPlanPermission((_to$meta2 = to.meta) === null || _to$meta2 === void 0 ? void 0 : _to$meta2.mcn_permission) ? nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index) : next(`/${i18n.locale}/access-denied`);
};
const hasRole = ({
  to,
  from,
  next
}, store, middlewares, index = 0) => {
  var _to$meta3;
  return store.getters.isRolePermitted((_to$meta3 = to.meta) === null || _to$meta3 === void 0 ? void 0 : _to$meta3.mcn_permitted_roles) ? nextMiddleware({
    to,
    from,
    next
  }, store, middlewares, index) : next(`/${i18n.locale}/access-denied`);
};
export { appDefaultMiddleware, emailVerification, isLogged, alreadyLogged, hasPermission, hasRole, isLoggedAndActive };